module.exports = __webpack_public_path__ + "static/img/page_PLAY01.a12924d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/_course/series2/course1/page_PLAY01.png
// module id = m5bI
// module chunks = 0